import { render } from "./TrailerRegister.vue?vue&type=template&id=585eddad&scoped=true"
import script from "./TrailerRegister.vue?vue&type=script&lang=js"
export * from "./TrailerRegister.vue?vue&type=script&lang=js"

import "./TrailerRegister.vue?vue&type=style&index=0&id=585eddad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585eddad"]])

export default __exports__